var render, staticRenderFns
import script from "./seo-header.vue?vue&type=script&lang=js&"
export * from "./seo-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('156bae62')) {
      api.createRecord('156bae62', component.options)
    } else {
      api.reload('156bae62', component.options)
    }
    
  }
}
component.options.__file = "frontend/static/js/components/seo-header.vue"
export default component.exports